import { useNavigate } from 'react-router-dom';
import { testimonials } from '@/mocks/articles';

const avatarImages: Record<number, string> = {
  1: 'https://readdy.ai/api/search-image?query=Stylish%20young%20Asian%20person%20avatar%20with%20trendy%20street%20fashion%20style%2C%20neon%20lit%20portrait%2C%20cyberpunk%20aesthetic%2C%20circular%20headshot%20format%2C%20clean%20background%20with%20subtle%20pink%20tones%2C%20editorial%20portrait%20photography&width=80&height=80&seq=test-avatar-1&orientation=squarish',
  2: 'https://readdy.ai/api/search-image?query=Professional%20looking%20young%20woman%20avatar%20with%20modern%20minimalist%20style%2C%20warm%20studio%20portrait%20lighting%2C%20clean%20circular%20headshot%20format%2C%20neutral%20grey%20background%2C%20editorial%20portrait%20photography&width=80&height=80&seq=test-avatar-2&orientation=squarish',
  3: 'https://readdy.ai/api/search-image?query=Casual%20young%20male%20avatar%20with%20laid-back%20street%20style%2C%20moody%20warm%20portrait%20lighting%2C%20circular%20headshot%20format%2C%20dark%20atmospheric%20background%2C%20editorial%20portrait%20photography&width=80&height=80&seq=test-avatar-3&orientation=squarish',
  4: 'https://readdy.ai/api/search-image?query=Intellectual%20looking%20young%20person%20avatar%20with%20glasses%20and%20thoughtful%20expression%2C%20soft%20studio%20lighting%2C%20circular%20headshot%20format%2C%20clean%20warm%20background%2C%20editorial%20portrait%20photography&width=80&height=80&seq=test-avatar-4&orientation=squarish',
  5: 'https://readdy.ai/api/search-image?query=Playful%20young%20student%20avatar%20with%20casual%20hoodie%20style%2C%20bright%20and%20energetic%20portrait%20lighting%2C%20circular%20headshot%20format%2C%20simple%20background%20with%20warm%20tones%2C%20editorial%20portrait%20photography&width=80&height=80&seq=test-avatar-5&orientation=squarish',
  6: 'https://readdy.ai/api/search-image?query=Sophisticated%20young%20professional%20avatar%20with%20refined%20style%2C%20elegant%20studio%20portrait%20lighting%2C%20circular%20headshot%20format%2C%20sophisticated%20dark%20background%2C%20editorial%20portrait%20photography&width=80&height=80&seq=test-avatar-6&orientation=squarish',
};

export default function Testimonials() {
  const navigate = useNavigate();

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full border border-secondary-500/40 text-secondary-400 text-xs font-medium mb-4 whitespace-nowrap">
            用户口碑
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-50 mb-3">
            吃瓜群众怎么说
          </h2>
          <p className="text-sm md:text-base text-foreground-300 max-w-xl mx-auto">
            来自280万真实用户的好评，口碑是我们最好的广告
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {testimonials.map((t) => (
            <div key={t.id} className="bg-background-200 border border-background-300 rounded-2xl p-5 md:p-6 transition-all duration-300 hover:bg-background-300 hover:border-background-400">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-300">
                  <img src={avatarImages[t.id]} alt={t.name} className="w-full h-full object-cover" />
                </div>
                <div>
                  <h4 className="text-sm font-heading font-bold text-foreground-50 whitespace-nowrap">{t.name}</h4>
                  <p className="text-xs text-foreground-400 whitespace-nowrap">{t.role}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-300 leading-relaxed mb-4">
                {t.content}
              </p>
              <div className="flex items-center gap-0.5">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className={`${i < t.rating ? 'ri-star-fill text-secondary-400' : 'ri-star-line text-foreground-600'} text-sm`}
                  ></i>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}